var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"date"},domProps:{"value":_vm.innerValue},on:{"input":function($event){_vm.updateValue($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }